var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cng-container *ngIf=\"count\"\u003E\u003Cspan class=\"badge\" [ngClass]=\"className\" id=\"badge\"\u003E{{ count }}\u003C\u002Fspan\u003E\u003C\u002Fng-container\u003E";;return pug_html;};
module.exports = template;